import { type ApplicationFormValue } from "./type";
import deepmerge from "deepmerge";

export const copyContractorToShipmentIfSelectSame = (value: ApplicationFormValue): ApplicationFormValue => {
  if (value.shippingAddressSameOrNew === "new") {
    return value;
  }

  // deep copy
  const copyValue = deepmerge<ApplicationFormValue>(value, {});
  copyValue.shippingAddress = copyValue.customerAddress;

  return copyValue;
};
